import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { capitalizeEveryWord, joinClassnames, validateStringForXSS } from '../utils';

export const FullTranscriptModal = (props: any) => {
  const {
    showFullTranscript,
    setShowFullTranscript,
    currentCitation,
    currentInterviewDate,
    currentTranscript,
    currentSorce,
    highScore,
    matchingScore,
  } = props;

  return (
    <Transition.Root show={showFullTranscript} as={Fragment}>
      <Dialog as="div" className="relative z-[100]" onClose={() => setShowFullTranscript(false)}>
        {/* Opaque overlay */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-70 transition-opacity" />
        </Transition.Child>

        {/* Modal panel */}
        <div className="fixed inset-0 z-10 ">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4"
              enterTo="opacity-100 translate-y-0"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-4"
            >
              <Dialog.Panel className="relative flex max-w-[86vw] max-h-[86vh] pb-[36px] transform flex-col gap-8 bg-[#FFFFFF] p-8 font-graphik text-white transition-all border-t-[4px] border-purple-600">
                <div className="flex justify-between items-center">
                  <div className="flex justify-between items-center gap-8">
                    <span className="text-[20px] text-[#000] font-medium">Response Details</span>
                    <p
                      className={joinClassnames(
                        currentSorce === 'Primary' ? 'text-[#505050]' : '',
                        currentSorce === 'Secondary' ? 'text-[#A100FF]' : '',
                        'primary-badge text-[10px] leading-[normal] font-normal font-inter capitalize tracking-[0.28px] bg-[#E6DCFF] px-[8px] py-1 '
                      )}
                    >
                      {currentSorce}
                    </p>
                  </div>
                  <button
                    onClick={() => setShowFullTranscript(false)}
                    className="flex items-center justify-center text-black w-6 min-w-[24px] h-6 min-h-[24px] rounded-full bg-white hover:bg-opacity-70 focus:outline-none"
                  >
                    <span className="material-symbols-outlined material-symbols-outlined-bold text-[20px]">close</span>
                  </button>
                </div>
                <div className="transcript-data-wrapper flex flex-col gap-6 flex-grow overflow-hidden">
                  <div className="flex justify-between">
                    <div className="flex flex-col flex-1 gap-1 font-medium">
                      <div className="text-[#000]">Matching Score</div>
                      <div className="text-gamma-standard-purple text-[14px]">{matchingScore}</div>
                    </div>
                    {currentInterviewDate && (
                      <div className="flex flex-col flex-1 gap-1">
                        <span className="text-[#000] font-medium">Dated</span>
                        <span className="text-[#000] text-[14px]">{currentInterviewDate}</span>
                      </div>
                    )}
                    <div className="flex flex-col flex-1 gap-1">
                      <span className="text-[#000] font-medium">Citation</span>
                      <span
                        className="text-[#000] text-[14px]"
                        dangerouslySetInnerHTML={{
                          __html: validateStringForXSS(capitalizeEveryWord(currentCitation ?? '')),
                        }}
                      ></span>
                    </div>
                  </div>
                  <div className="transcript-content flex flex-col gap-2 flex-grow overflow-y-auto">
                    <h3 className="text-[#000] font-medium  text-left">Transcript Preview</h3>
                    <p
                      className="text-[#000] text-left text-[14px] leading-[24px] pr-8 Scrollbar"
                      dangerouslySetInnerHTML={{
                        __html: validateStringForXSS(currentTranscript),
                      }}
                    ></p>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
